import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ComboBox from '../../../../Components/ComboBox'
import { Input } from '../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePutRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'

import { convertToMuiDate } from '../../../../utils/helpers'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function EditOperationForm({ setOperations, params, operations, setSelected }) {
  const [open, setOpen] = useState(true)
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [classification, setClassification] = useState([{ label: 'new' }])
  const [classificationSelected, setClassificationSelected] = useState({})
  const [tempCategory, settempCategory] = useState([])
  const [Category, setCategory] = useState([])
  const [CategorySelected, setCategorySelected] = useState({})
  const [SubCategory, setSubCategory] = useState([])
  const [SubCategorySelected, setSubCategorySelected] = useState({})

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      id: params[0].id,
      Date: params[0].Date ? convertToMuiDate(params[0].Date) : '',
      Libelle: params[0].Libelle,
      Classification: '',
      Category: '',
      SubCategory: '',
      Montant: params[0].Montant,

      Devise: params[0].Devise,
    },
  })

  const log = (classifcation_list, tempCategory) => {
    let cf = classifcation_list.filter((v) => params[0].Classification === v.label)
    if (cf.length > 0) {
      setClassificationSelected(cf[0])
      setValue('Classification', cf[0])
      let check = []
      let check_list = []
      tempCategory.forEach((v) => {
        if (v.Classification === cf[0].label && !check.includes(v.Categorie)) {
          check.push(v.Categorie)
          check_list.push({ label: v.Categorie, id: v.id })
        }
      })
      setCategory(check_list)
      let cat = check_list.filter((v) => params[0].Category === v.label)
      if (cat.length > 0) {
        setValue('Category', cat[0])
        setCategorySelected(cat[0])
        let check2 = []
        let check_list2 = []
        tempCategory.forEach((v) => {
          if (v.Categorie === cat[0].label && !check2.includes(v.SousCategorie)) {
            check2.push(v.SousCategorie)
            check_list2.push({ label: v.SousCategorie, id: v.id })
          }
        })
        setSubCategory(check_list2)
        let subcat = check_list2.filter((v) => params[0].SousCategorie === v.label)
        if (subcat.length > 0) {
          setValue('SubCategory', subcat[0])
          setSubCategorySelected(subcat[0])
        }
      }
    }
  }

  useEffect(() => {
    fetchCategoryFi()
  }, [])

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }
  const fetchCategoryFi = async () => {
    const url = urls.fetchCategories + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      let ccheck = []
      let classifcation_list = []
      data.forEach((v) => {
        if (!ccheck.includes(v.Classification)) {
          ccheck.push(v.Classification)
          classifcation_list.push({ label: v.Classification, id: v.id })
        }
      })
      setClassification(classifcation_list)
      settempCategory(data)
      log(classifcation_list, data)
    }
  }
  const onSubmit = async (data) => {
    const payload = {
      ...data,
      Classification: data.Classification.label,
      Category: data.Category.label,
      SousCategorie: data.SubCategory.label,
      TypeOperation: 'D',
    }
    const response = await makePutRequest(
      urls.crudBudgetOpertations + `${data.id}/`,
      payload,
      {},
      true,
    )

    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))

      handleClose()
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('finance.monBudget.editOperationTitle')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              InputLabelProps={{ shrink: true }}
              rules={{ required: true }}
              name="Date"
              label={t('finance.common.date')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Libelle"
              label={t('finance.monBudget.columnLibelle')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Montant"
              label={t('finance.monBudget.columnAmount')}
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Classification', j)
                setClassificationSelected(j)
                let check = []
                let check_list = []
                tempCategory.forEach((v) => {
                  if (j && v.Classification === j.label && !check.includes(v.Categorie)) {
                    check.push(v.Categorie)
                    check_list.push({ label: v.Categorie, id: v.id })
                  }
                })
                setCategory(check_list)
                setValue('Category', '')
                let s = document.getElementsByName('SubCategory')

                if (s.length > 0) {
                  s = s[0].getElementsByClassName('MuiAutocomplete-clearIndicator')
                  if (s.length > 0) {
                    s[0].click()
                  }
                }
                setValue('SubCategory', '')
                let v = document.getElementsByName('Category')

                if (v.length > 0) {
                  v = v[0].getElementsByClassName('MuiAutocomplete-clearIndicator')
                  if (v.length > 0) {
                    v[0].click()
                  }
                }
              }}
              label={t('finance.monBudget.columnClassification')}
              data={classification}
              name="Classification"
              required={true}
              selectedValue={classificationSelected}
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Category', j)
                setCategorySelected(j)
                let check = []
                let check_list = []
                tempCategory.forEach((v) => {
                  if (j && v.Categorie === j.label && !check.includes(v.SousCategorie)) {
                    check.push(v.SousCategorie)
                    check_list.push({ label: v.SousCategorie, id: v.id })
                  }
                })
                setSubCategory(check_list)
                setValue('SubCategory', '')
                let s = document.getElementsByName('SubCategory')

                if (s.length > 0) {
                  s = s[0].getElementsByClassName('MuiAutocomplete-clearIndicator')
                  if (s.length > 0) {
                    s[0].click()
                  }
                }
              }}
              label={t('finance.monBudget.columnCategory')}
              data={Category}
              name="Category"
              required={true}
              selectedValue={CategorySelected}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('SubCategory', j)
                setSubCategorySelected(j)
              }}
              label={t('finance.monBudget.columnSubCategory')}
              data={SubCategory}
              name="SubCategory"
              required={true}
              selectedValue={SubCategorySelected}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Devise"
              label={t('finance.monBudget.columnCurrency')}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('finance.common.confirm')}</Button>
            <Button onClick={handleClose}>{t('finance.common.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
